import {
  PEELING_DONE_LIST_FAILED,
  PEELING_DONE_LIST_REQUEST,
  PEELING_DONE_LIST_SUCCESS,
} from "app/redux/actions/Factory/Peeling/peelingDoneListing/constants";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const peelingDoneReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case PEELING_DONE_LIST_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case PEELING_DONE_LIST_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case PEELING_DONE_LIST_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
